<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <router-link to="/" tag='div'>
        <v-img class="pointer"
            height="50"
            width="150"
            src="./assets/RIFTBOYSlogo.png"
        ></v-img>
      </router-link>

      <v-spacer></v-spacer>

      <v-btn text to="/About">
        About
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>

<style scoped>
.pointer { 
  cursor: pointer;
}

</style>